// src/stores/useNoteTypeStore.js
import { defineStore } from 'pinia';
import * as noteTypeService from '@/services/noteTypeService';

export const useNoteTypeStore = defineStore("noteType", {
  state: () => ({
    noteTypes: [],
    selectedNoteTypeIds: [],
    idNoteType: null,
    error: null,
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
    searchTerm: "", // 🔍 novo campo para busca
    shouldForcePageOne: false,
  }),

  getters: {
    isAllSelected: (state) => (total) => {
      return state.selectedNoteTypeIds.length === total;
    },
  },

  actions: {
    setIdNoteType(id) {
      this.idNoteType = id;
    },

    toggleSelection(id) {
      const index = this.selectedNoteTypeIds.indexOf(id);
      if (index > -1) {
        this.selectedNoteTypeIds.splice(index, 1);
      } else {
        this.selectedNoteTypeIds.push(id);
      }
    },

    selectAll(ids) {
      this.selectedNoteTypeIds = [...ids];
    },

    clearSelection() {
      this.selectedNoteTypeIds = [];
    },

    async fetchNoteTypes() {
      try {
        const response = await noteTypeService.fetchNoteTypes();
        this.noteTypes = response.data;
      } catch (error) {
        // Refatorado para extrair a mensagem de forma robusta
        const mensagem =
          error.response?.data?.message ||
          error.response?.data ||
          error.message;
        this.error = mensagem;
        console.error("❌ Erro ao buscar tipos de notas:", mensagem);
        throw new Error(mensagem);
      }
    },

    async getNoteTypeById(id) {
      try {
        const response = await noteTypeService.getNoteTypeById(id);
        return response.data;
      } catch (error) {
        // Refatorado
        const mensagem =
          error.response?.data?.message ||
          error.response?.data ||
          error.message;
        console.error("❌ Erro ao obter tipo de nota:", mensagem);
        throw new Error(mensagem);
      }
    },

    async createNoteType(data) {
      try {
        const response = await noteTypeService.createNoteType(data);
        this.shouldForcePageOne = true;
        await this.fetchNoteTypesPaged(1, this.pageSize, this.searchTerm);
        return response.data;
      } catch (error) {
        
        console.error("❌ Erro ao cadastrar tipo de nota:", error.mensagem);
        throw error;
      }
    },

    async updateNoteType(data) {
      try {
        await noteTypeService.updateNoteType(data);
        const index = this.noteTypes.findIndex(
          (a) => a.noteTypeId === data.noteTypeId
        );
        if (index !== -1) {
          this.noteTypes[index] = { ...data };
        }
      } catch (error) {
        console.error("❌ Erro ao atualizar tipo de nota:", error.mensagem);
        throw error;
      }
    },

    async deleteNoteTypeById(id) {
      try {
        await noteTypeService.deleteNoteType(id);
        await this.fetchNoteTypesPaged(
          this.currentPage,
          this.pageSize,
          this.searchTerm
        );
        if (this.noteTypes.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
          await this.fetchNoteTypesPaged(
            this.currentPage,
            this.pageSize,
            this.searchTerm
          );
        }
      } catch (error) {
        // Refatorado (já estava usando .message aqui, mas reforçando a cadeia de verificação)
        const mensagem =
          error.response?.data?.message ||
          error.response?.data ||
          error.message;
        console.error("❌ Erro ao excluir tipo de nota:", mensagem);
        throw new Error(mensagem);
      }
    },

    async deleteSelectedNoteTypes() {
      if (!this.selectedNoteTypeIds.length) return;

      try {
        await noteTypeService.deleteNoteTypesBatch(this.selectedNoteTypeIds);
        this.clearSelection();
        await this.fetchNoteTypesPaged(
          this.currentPage,
          this.pageSize,
          this.searchTerm
        );
        if (this.noteTypes.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
          await this.fetchNoteTypesPaged(
            this.currentPage,
            this.pageSize,
            this.searchTerm
          );
        }
      } catch (error) {
        // Refatorado (já estava usando .message aqui, mas reforçando a cadeia de verificação)
        const mensagem =
          error.response?.data?.message ||
          error.response?.data ||
          error.message;
        console.error("❌ Erro ao excluir tipos de notas em lote:", mensagem);
        throw new Error(mensagem);
      }
    },

    async fetchNoteTypesPaged(pageNumber, pageSize, search) {
      try {
        const response = await noteTypeService.fetchNoteTypesPaged(
          pageNumber,
          pageSize,
          search
        );
        this.noteTypes = response.data.data;
        this.totalCount = response.data.totalCount;
        this.totalPages = response.data.totalPages;
        this.currentPage = pageNumber;
      } catch (error) {
        // Refatorado
        const mensagem =
          error.response?.data?.message ||
          error.response?.data ||
          error.message;
        this.error = mensagem;
        console.error("❌ Erro ao buscar tipos de notas paginados:", mensagem);
        throw new Error(mensagem);
      }
    },

    setSearchTerm(term) {
      this.searchTerm = term;
      this.currentPage = 1; // 🔁 redefine a página
      this.shouldForcePageOne = true; // 🔁 aciona o highlight no BottomPagination
      this.fetchNoteTypesPaged(1, this.pageSize, term); // 🔍 dispara a busca
    },
  },
});
